import { useState, useRef, useCallback, useEffect } from "react";
import { createEvent } from "../../utils/createEvent.js";
const useDelay = ({
  value: externalValue,
  onChange,
  name,
  delay = 0
}) => {
  const [internalValue, setInternalValue] = useState(externalValue), ref = useRef({
    tmt: 0,
    onChange
  });
  ref.current.onChange = onChange;
  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      typeof externalValue < "u" && setInternalValue(value), clearTimeout(ref.current.tmt), ref.current.tmt = setTimeout(() => {
        var _a, _b;
        (_b = (_a = ref.current).onChange) == null || _b.call(_a, createEvent({ name, value }));
      }, delay);
    },
    [delay, name, externalValue]
  );
  return useEffect(() => {
    externalValue !== internalValue && setInternalValue(externalValue ?? "");
  }, [externalValue]), { internalValue, handleChange };
};
export {
  useDelay
};
//# sourceMappingURL=useDelay.js.map
